var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"Loading d-flex justify-center align-center",class:_vm.position ? 'Loading-Absolute':''},[_c('img',{attrs:{"src":require("@/assets/img/loader.svg")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }